'use strict';

const { handleAppleClaimLocationsSocket } = require('./sockets/claim/appleClaimLocationsSocket');
const { handleBingClaimLocationsSocket } = require('./sockets/claim/bingClaimLocationsSocket');
const { handleGoogleClaimLocationsSocket } = require('./sockets/claim/googleClaimLocationsSocket');

const claimStates = ({ elm }) => {
	return [
		{
			name: 'site.ClaimFacebook',
			url: '/claim/facebook',
			templateUrl: 'components/claim/facebook/overview.html',
			controller: 'ClaimFacebookOverviewCtrl',
			requiredPermission: 'permission/claim.manage'
		},
		{
			name: 'site.ClaimFacebookDiscardList',
			url: '/claim/facebook/discard',
			templateUrl: 'components/claim/facebook/discard.html',
			controller: 'ClaimFacebookDiscardCtrl',
			requiredPermission: 'permission/claim.manage'
		},
		elm({
			name: 'site.ClaimGoogle',
			moduleName: 'Tasks.Google.Claim.Main',
			url: '/claim/google',
			requiredPermission: 'permission/claim.manage',
			pageTitle: 'listings.navigation.claim_google',
			argsResolver: [
				'$window',
				'$stateParams',
				'auth',
				'pmtEnvService',
				'pmtElmService',
				($window, $stateParams, auth, pmtEnvService, pmtElmService) => {
					handleGoogleClaimLocationsSocket(
						$window,
						pmtEnvService.listingsManagerUrl,
						$stateParams.site,
						pmtElmService
					);
					return auth.getUser($stateParams.site).then(user => {
						return {
							categories: user.selectedSite.places?.google?.categories
						};
					});
				}
			]
		}),
		elm({
			name: 'site.ClaimApple',
			moduleName: 'Tasks.Apple.Claim.Main',
			url: '/claim/apple',
			requiredPermission: 'permission/claim.manage',
			pageTitle: 'listings.navigation.claim_apple',
			argsResolver: [
				'$window',
				'$stateParams',
				'auth',
				'pmtEnvService',
				'pmtElmService',
				($window, $stateParams, auth, pmtEnvService, pmtElmService) => {
					handleAppleClaimLocationsSocket(
						$window,
						pmtEnvService.listingsManagerUrl,
						$stateParams.site,
						pmtElmService
					);
					return auth.getUser($stateParams.site).then(user => {
						const apple = user.selectedSite.places?.apple;
						const lastRun = apple?.activity?.locationFinder?.lastRun
							? String(apple.activity.locationFinder.lastRun)
							: null;
						const appleConnectionType = user.selectedSite.analytics?.apple?.connectionType || '';
						return {
							categories: apple?.categories,
							lastRun,
							appleConnectionType
						};
					});
				}
			]
		}),
		elm({
			name: 'site.ClaimHere',
			moduleName: 'Tasks.Here.Claim.Main',
			url: '/claim/here',
			requiredPermission: 'permission/claim.manage',
			pageTitle: 'listings.navigation.claim_here',
			argsResolver: [
				'$stateParams',
				'auth',
				($stateParams, auth) => {
					return auth.getUser($stateParams.site).then(user => {
						const here = user.selectedSite.places?.here;
						return {
							categories: here?.categories
						};
					});
				}
			]
		}),
		elm({
			name: 'site.ClaimTomtom',
			moduleName: 'Tasks.Tomtom.Claim.Main',
			url: '/claim/tomtom',
			requiredPermission: 'permission/claim.manage',
			pageTitle: 'listings.navigation.claim_tomtom',
			argsResolver: [
				'$stateParams',
				'auth',
				($stateParams, auth) => {
					return auth.getUser($stateParams.site).then(user => {
						const tomtom = user.selectedSite.places?.tomtom;
						return {
							category: tomtom?.category
						};
					});
				}
			]
		}),
		elm({
			name: 'site.ClaimBing',
			moduleName: 'Tasks.Bing.Claim.Main',
			url: '/claim/bing',
			requiredPermission: 'permission/claim.manage',
			pageTitle: 'listings.navigation.claim_bing',
			argsResolver: [
				'$window',
				'$stateParams',
				'auth',
				'pmtEnvService',
				'pmtElmService',
				($window, $stateParams, auth, pmtEnvService, pmtElmService) => {
					handleBingClaimLocationsSocket(
						$window,
						pmtEnvService.listingsManagerUrl,
						$stateParams.site,
						pmtElmService
					);
					return auth.getUser($stateParams.site).then(user => {
						const bing = user.selectedSite.places?.bing;
						const lastRun = bing?.activity?.locationFinder?.lastRun
							? String(bing.activity.locationFinder.lastRun)
							: null;

						return {
							categories: bing?.categories,
							primaryCategoryId: bing?.primaryCategoryId,
							lastRun
						};
					});
				}
			]
		}),
		elm({
			name: 'site.ClaimFoursquare',
			moduleName: 'Tasks.Foursquare.Claim.Main',
			url: '/claim/foursquare',
			requiredPermission: 'permission/claim.manage',
			pageTitle: 'listings.navigation.claim_foursquare',
			argsResolver: [
				'$stateParams',
				'auth',
				($stateParams, auth) => {
					return auth.getUser($stateParams.site).then(user => {
						const factual = user.selectedSite.places?.factual;
						return {
							categories: factual?.categories
						};
					});
				}
			]
		}),
		elm({
			name: 'site.ClaimOverture',
			moduleName: 'Tasks.Overture.Claim.Main',
			url: '/claim/overture',
			requiredPermission: 'permission/claim.manage',
			pageTitle: 'listings.navigation.claim_overture',
			argsResolver: [
				'$stateParams',
				'auth',
				($stateParams, auth) => {
					return auth.getUser($stateParams.site).then(user => {
						const overture = user.selectedSite.places?.overture;
						return {
							categories: overture?.categories
						};
					});
				}
			]
		}),
		elm({
			name: 'site.ClaimTrustpilot',
			moduleName: 'Tasks.Trustpilot.Claim.Main',
			url: '/claim/trustpilot',
			requiredPermission: 'permission/claim.manage',
			pageTitle: 'listings.navigation.claim_trustpilot'
		}),
		elm({
			name: 'site.ClaimPTV',
			moduleName: 'Tasks.PTV.Claim.Main',
			url: '/claim/ptv',
			argsResolver: [
				'$stateParams',
				'auth',
				($stateParams, auth) => {
					return auth.getUser($stateParams.site).then(user => {
						return {
							isTwoWay: !!user.selectedSite.places?.feature?.allowPtvTwoWay?.enabled
						};
					});
				}
			],
			requiredPermission: 'permission/claim.manage',
			pageTitle: 'listings.navigation.claim_ptv'
		})
	];
};

module.exports = {
	claimStates
};
